import React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { usePagination, useSettings } from 'app/main/components';
import { type MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';
import ViewPageContentWrapper from 'app/main/components/page-layouts/view/ViewPageContentWrapper';

import CommercialCampaignsRowsListItem from '../commercialcampaigns/commercialcampaigns-rows/CommercialCampaignsRowsListItem';
import DemsRecipientsModuleTableColumns from '../dems/DemsRecipientsModuleTableColumns';
import MarketingActionsRowsListItem from '../marketingactions/marketingactions-rows/MarketingActionsRowsListItem';

interface ImportFromRowsPreviewDialogProps {
	title: string;
	module: string;
	defaultFilters?: MiddlewhereFilter[];
	defaultQuery?: any;
	addRows: VoidFunction;
	goBack: VoidFunction;
}

const pageContent = {
	commercialcampaigns_rows: { type: 'list', itemLayout: CommercialCampaignsRowsListItem },
	dems_recipients: { type: 'table', getColumns: DemsRecipientsModuleTableColumns },
	marketingactions_rows: { type: 'list', itemLayout: MarketingActionsRowsListItem }
};

function ImportFromRowsPreviewDialog(props: ImportFromRowsPreviewDialogProps) {
	const { t } = useSettings();

	const paginationProps = usePagination({
		module: props.module,
		filter: {
			defaultFilters: props.defaultFilters,
			defaultQuery: props.defaultQuery
		}
	});

	const [refresh, setRefresh] = React.useState(false);
	const updateRefresh = () => setRefresh(state => !state);

	return (
		<>
			<DialogTitle>{props.title}</DialogTitle>
			<DialogContent className="flex flex-col p-0">
				<ViewPageContentWrapper
					module={props.module}
					content={pageContent[props.module]}
					paginationProps={paginationProps}
					refresh={refresh}
					updateRefresh={updateRefresh}
					showFilters={false}
					showExportButton={false}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.goBack}>{t('DIALOG_ACTION_BACK')}</Button>
				<Button color="secondary" onClick={props.addRows}>
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}

export default ImportFromRowsPreviewDialog;
